import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TraineeListService } from '../../service/trainee-list.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ChatService } from '../../service/chat-service';
import { SelectionModel } from '@angular/cdk/collections';
import { AssignedTo, AssignScenario } from '../../model/chat.model';
import { ToastrService } from 'ngx-toastr';
import { ConstantConfig } from '../../utility/constant-config';
import { PlatformRegionService } from '../../service/shared/platform-region.service';

@Component({
    selector: 'app-roleplay-assign',
    templateUrl: './roleplay-assign.component.html',
    styleUrl: './roleplay-assign.component.scss',
    standalone: false
})

export class RoleplayAssignComponent {
  config: any = ConstantConfig;
  displayedColumns: string[] = ['select', 'wwid', 'first_name', 'last_name', 'assigned_date', 'assigned_status']; //'avtar_enabled'
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) private paginator: MatPaginator;
  hasChange: boolean = false;
  initialSelection = [];
  allowMultiSelect = true;
  selection: any = [];
  scenarioId: number = 0;
  dataSource: any = new MatTableDataSource();
  response: any = [];
  userId: number = 0;
  filterValue: string;
  defaultSelectedRows: any = [];
  toggleState: { [key: number]: boolean } = {};
  showNoSearchResultsMessage: boolean = false;
  enabledAvatarsArray: boolean[] = [];

  constructor(public Router: Router, private _liveAnnouncer: LiveAnnouncer, private route: ActivatedRoute,
    public TraineeService: TraineeListService, private chatService: ChatService, private toastr: ToastrService,
    private platformRegionService: PlatformRegionService) { }

  ngOnInit() {
    this.userId = Number(sessionStorage.getItem('userId'));
    this.scenarioId = Number(this.route.snapshot.queryParamMap.get('id'));
    this.selection = new SelectionModel<any>(this.allowMultiSelect, this.initialSelection);
    this.getTraineeList();
  }
  getTraineeList() {
    const bu = this.platformRegionService.selected_platform_code;
    const region = this.platformRegionService.selected_region_code;
    this.chatService.getTraineeListByScenarioId(this.scenarioId, bu, region).subscribe(res => {
      this.response = res;
      this.setDefaultRowSelected();
      const alteredResponse = res.map(item => item.avtar_enabled === null ? { ...item, avtar_enabled: false } : { ...item, avtar_enabled: item.avtar_enabled });
      this.dataSource = new MatTableDataSource(alteredResponse);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  toggle(wwid: number) {
    this.toggleState[wwid] = !this.toggleState[wwid];
  }

  applyFilter(value: string) {
    this.filterValue = value.trim().toLowerCase();
    this.dataSource.filter = this.filterValue;
    if (this.dataSource.filteredData.length === 0 && this.filterValue !== '') {
      this.showNoSearchResultsMessage = true; // Set a flag to indicate no search results
    } else {
      this.showNoSearchResultsMessage = false; // Reset the flag
    }
  }

  isRowSelected(row: any) {
    return this.selection.selected.some(s => s.wwid == row.wwid)
  }

  isRoleplayCompleted(row: any) {
    return row.status?.toLowerCase() == 'completed'
  }

  setDefaultRowSelected() {
    this.selection.clear();
    this.defaultSelectedRows = [];
    this.response.map((item) => {
      if (item.assigned_status.toLowerCase() == 'assigned') {
        this.defaultSelectedRows.push(item);
        this.selection.toggle(item)
      }
    });
  }

  onCheckboxChange(row: any): void {
    this.hasChange = true;
    const selectionRow = this.selection?.selected?.find(s => s.wwid == row.wwid);
    if (selectionRow) {
      this.selection.toggle(selectionRow);
    } else {
      this.selection.toggle(row);
    }
  }


  submit() {
    if (!this.hasChange) {
      this.toastr.error('No changes detected in selection');
      return;
    }
    if (this.selection.selected.length == 0 && this.defaultSelectedRows.length == 0) {
      this.toastr.error('Please select at least one row before submitting.');
      return;
    }
    const selectedRows: any[] = this.selection.selected;
    let selectedUsers: any = [];
    selectedRows.forEach((item: any) => {
      selectedUsers.push(item.wwid);
      // Unassign roleplay
      this.unassignRoleplay(item);
    });

    selectedUsers = [...new Set(selectedUsers)];
    const vatar_en = selectedRows.filter(e => e.avtar_enabled === true).map(e => e.wwid);
    const dataResult = selectedRows.reduce((acc, e, i) => {
      acc[e.wwid] = e['avtar_enabled'];
      return acc;
    }, {});

    const assigned_to: any[] = Object.keys(dataResult)
    const request: AssignScenario = {
      roleplay_scenario_id: [this.scenarioId],
      assigned_to: assigned_to,
      assigned_by: this.userId,
      avtar_enabled: Object.values(vatar_en),
      business_unit_code: this.platformRegionService.selected_platform_code,
      region: this.platformRegionService.selected_region_code
    };



    //   const request: AssignScenario = {
    //     roleplay_scenario_id: this.scenarioId,
    //     assigned_to: [...new Set(selectedUsers)].map(e => Number(e)),
    //     assigned_by: this.userId,
    //     avtar_enabled: Object.values(this.toggleState).map(e => e.toString()),
    //     // assigned_to: Object.keys(this.toggleState).map(e => Number(e))
    // };

    this.chatService.assignScenario(request).subscribe((res) => {
      this.toastr.success('Submitted Successfully');
      this.getTraineeList();
    });
  }

  unassignRoleplay(row: any) {
    const index = this.defaultSelectedRows.findIndex(item => item === row);
    if (index !== -1) {
      this.defaultSelectedRows.splice(index, 1);
    }
  }
  redirectToAssignScenario(): void {
    this.Router.navigate(['/roleplay/training-dashboard'], { skipLocationChange: true });
  }
  isAllSelected() {
    const selectableRows = this.dataSource.filteredData.filter(row => !this.isRoleplayCompleted(row));
    if (selectableRows.length === 0) return false;
    return selectableRows.every(row => this.isRowSelected(row));
  }

  toggleAllRows() {
    this.hasChange = true;
    const selectableRows = this.dataSource.filteredData.filter(row => !this.isRoleplayCompleted(row));
    if (this.isAllSelected()) {
      selectableRows.forEach(row => {
        const selectionRow = this.selection.selected.find(s => s.wwid == row.wwid);
        if (selectionRow) {
          this.selection.deselect(selectionRow);
        }
      });
    } else {
      selectableRows.forEach(row => {
        if (!this.isRowSelected(row)) {
          this.selection.select(row);
        }
      });
    }
  }

  sortData(sort: Sort) {
    if (sort.direction) {
      this._liveAnnouncer.announce(`Sorted ${sort.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

}